import { useCallback } from "react";

import { useSendbird } from "@sendbird/uikit-react";

import useAppMonitor from "@/services/AppMonitor";

const useSendbirdSDK = () => {
  const {
    actions: { disconnect },
    state: {
      config: {
        // actions.disconnect requires logger as a param (no internal default)
        logger,
      },
      stores: {
        sdkStore: { initialized: isSendbirdConnected },
      },
    },
  } = useSendbird();
  const { captureException } = useAppMonitor();

  // SendBirdProvider on web auto-connects once appId and userId are valid; token rotation
  // is handled by the configureSession prop on the Provider. connectSendbird here is a no-op
  // and only kept for typing consistency w.r.t. native.
  const connectSendbird = useCallback(
    // eslint-disable-next-line no-empty-function, @typescript-eslint/no-empty-function -- lodash/noop doesn't apply to Promises/with args
    async (_userId: string): Promise<void> => {},
    [],
  );

  const disconnectSendbird = useCallback(
    async (_unused: {
      // push notifications do not apply to web, only native; typing kept to be consistent with native usage
      pushToken: null | string;
      shouldUnregisterPushToken?: boolean;
    }): Promise<void> => {
      try {
        await disconnect({ logger });
      } catch (error) {
        captureException(error);
      }
    },
    [captureException, disconnect, logger],
  );

  return {
    connectSendbird,
    disconnectSendbird,
    isSendbirdConnected,
  };
};

export default useSendbirdSDK;
